import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { Switch } from 'react-router-dom';

import styled from '@emotion/styled';
import classnames from 'classnames';

import { useBody, withWidget } from '@ezbobdev/ui-commons';

import MaterialAlerts from '../MaterialAlerts/MaterialAlerts';

const Wrapper = styled.div``;

const BodyContent = styled.div`
  margin: 0 auto;
`;

const MaterialBody = (props) => {
  const { alerts, screensContent, headerHeight, progressBarHeight, wrapperClasses } = useBody(props);

  return useMemo(
    () => (
      <Wrapper
        className={wrapperClasses}
        displayModal={screensContent.length}
        headerHeight={headerHeight}
        progressBarHeight={progressBarHeight}
      >
        <BodyContent className={classnames('BodyContent')}>
          {Boolean(alerts.length) && <MaterialAlerts />}

          {Boolean(screensContent.length) && (
            <div className="Screen">{screensContent[screensContent.length - 1].content}</div>
          )}

          <Switch>{props.children}</Switch>
        </BodyContent>
      </Wrapper>
    ),
    [alerts.length, wrapperClasses, props.children, screensContent.length, headerHeight, progressBarHeight],
  );
};

MaterialBody.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default React.memo(withWidget(MaterialBody));
